import { render, staticRenderFns } from "./InternalAppointmentCommentForm.vue?vue&type=template&id=c09a84ac"
import script from "./InternalAppointmentCommentForm.vue?vue&type=script&lang=ts"
export * from "./InternalAppointmentCommentForm.vue?vue&type=script&lang=ts"
import style0 from "./InternalAppointmentCommentForm.vue?vue&type=style&index=0&id=c09a84ac&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports